// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap_3SkXA","dim":"dim_yD9P6","dialog":"dialog_2IEMV","title":"title_2PWag","cancel":"cancel_1qaCm","content":"content_2C4cD"};